import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import moment from 'moment';
import { useState } from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import globalUseStyles from '../../../styles/globalCustomStyles';
import DetailsShow from '../../aegeon/cards/DetailsShow';
import QueryField from '../../aegeon/query/QueryField';
import { useQueryContext } from '../../aegeon/query/useQueryContext';
import SiteEnergeticPerformanceCRREM from './SiteEnergeticPerformance/SiteEnergeticPerformanceCRREM';
import SiteEnergeticPerformanceCRREMObjective from './SiteEnergeticPerformance/SiteEnergeticPerformanceCRREMObjective';
import SiteEnergeticPerformanceDeet from './SiteEnergeticPerformance/SiteEnergeticPerformanceDeet';
import SiteEnergeticPerformanceDPE from './SiteEnergeticPerformance/SiteEnergeticPerformanceDPE';
import SiteEnergeticPerformanceDPEMax from './SiteEnergeticPerformance/SiteEnergeticPerformanceDPEMax';
import SiteEnergeticPerformanceGeneral from './SiteEnergeticPerformance/SiteEnergeticPerformanceGeneral';

const DPE_USAGE_ENUM = [
    "BUREAUX",
    "OCCUPATION_CONTINUE",
    "CENTRE_COMMERCIAL",
    "LOGEMENT",
    "AUTRES_CAS",
];

const CRREM_USAGE_ENUM = [
    "OFFICE",
    "HEALTHCARE",
    "HOTEL",
    "INDUSTRIAL_DISTRIBUTION_WAREHOUSE",
    "INDUSTRIAL_DISTRIBUTION_WAREHOUSE_COOLED",
    "LODGING_LEISURE_AND_RECREATION",
    "RESIDENTIAL_MULTI_FAMILY",
    "RETAIL_HIGH_STREET",
    "RETAIL_SHOPPING_CENTER",
    "RETAIL_WAREHOUSE"
];

const SiteEnergeticPerformanceDetails = (props) => {
    const globalClasses = globalUseStyles();
    const t = useTranslate();
    const record = useRecordContext(props);
    const siteId = record?.id;
    let start = moment().subtract(2, "months").subtract(1, "year").startOf("year")
    let end = moment().subtract(2, "months").subtract(1, "year").endOf("year").set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const [startDate, setStartDate] = useState(start);
    const [endDate, setEndDate] = useState(end);
    const [dpeUsage, setDpeUsage] = useState(record?.airtable?.dpe_usage ? record?.airtable?.dpe_usage : DPE_USAGE_ENUM[0]);
    const [crremUsage, setCrremUsage] = useState(record?.airtable?.crrem_usage ? record?.airtable?.crrem_usage : CRREM_USAGE_ENUM[0]);

    const setYear = (year) => {
        setStartDate(moment().set({ year: year }).startOf("year"));
        setEndDate(moment().set({ year: year }).endOf("year").set({ hour: 0, minute: 0, second: 0, millisecond: 0 }));
    }

    const SiteEnergeticPerformanceComponent = (props) => {
        const { data, isLoading } = useQueryContext(props);
        const colors = { "energy": "#aad956", "ghg": "#bd99c4" };
        return (
            <Grid2 container spacing={4}>
                <Grid2 small={12} medium={12} big={12}>
                    <SiteEnergeticPerformanceGeneral
                        startDate={startDate}
                        endDate={endDate}
                        setYear={setYear}
                        dpeUsage={dpeUsage}
                        crremUsage={crremUsage}
                        setDpeUsage={setDpeUsage}
                        setCrremUsage={setCrremUsage}
                        dpeUsages={DPE_USAGE_ENUM}
                        crremUsages={CRREM_USAGE_ENUM}
                    />
                </Grid2>
                <Grid2 small={12} medium={6} big={4} >
                    <SiteEnergeticPerformanceDeet
                        type='DEET_PCS'
                        data={data}
                        isLoading={isLoading}
                        colors={colors}
                    />
                </Grid2>
                <Grid2 small={12} medium={6} big={4} >
                    <SiteEnergeticPerformanceDeet
                        type='DEET_PCI'
                        data={data}
                        isLoading={isLoading}
                        colors={colors}
                    />
                </Grid2>
                <Grid2 small={12} medium={6} big={4} >
                    <SiteEnergeticPerformanceDeet
                        type='DEET_GHG'
                        data={data}
                        isLoading={isLoading}
                        colors={colors}
                    />
                </Grid2>
                <Grid2 small={12} medium={6} big={4} >
                    <SiteEnergeticPerformanceDPE
                        type='DPE_ENEP'
                        data={data}
                        isLoading={isLoading}
                        usage={dpeUsage}
                    />
                </Grid2>
                <Grid2 small={12} medium={6} big={4} >
                    <SiteEnergeticPerformanceDPE
                        type='DPE_GHG'
                        data={data}
                        isLoading={isLoading}
                        usage={dpeUsage}
                    />
                </Grid2>
                <Grid2 small={12} medium={6} big={4} >
                    <SiteEnergeticPerformanceDPEMax
                        type='DPE_MAX'
                        data={data}
                        isLoading={isLoading}
                        usage={dpeUsage}
                        colors={colors}
                    />
                </Grid2>
                <Grid2 small={12} medium={6} big={4} >
                    <SiteEnergeticPerformanceCRREM
                        type='CRREM_PCS'
                        data={data}
                        isLoading={isLoading}
                        usage={crremUsage}
                        colors={colors}
                    />
                </Grid2>
                <Grid2 small={12} medium={6} big={4} >
                    <SiteEnergeticPerformanceCRREM
                        type='CRREM_GHG'
                        data={data}
                        isLoading={isLoading}
                        year={startDate ? new Date(startDate).getFullYear() : new Date().getFullYear() - 1}
                        usage={crremUsage}
                        colors={colors}
                    />
                </Grid2>
                <Grid2 small={12} medium={6} big={4} >
                    <SiteEnergeticPerformanceCRREMObjective
                        type="CRREM_OBJECTIVE"
                        data={data}
                        isLoading={isLoading}
                        year={startDate ? new Date(startDate).getFullYear() : new Date().getFullYear() - 1}
                        usage={crremUsage}
                        colors={colors}
                    />
                </Grid2>
            </Grid2>
        )
    }

    return (
        <DetailsShow title={t('sites.energetic_performance.title')} resource="sites" noMargin={true}>
            <div className={globalClasses.pageContent}>
                <QueryField
                    key={startDate?.toString() + endDate?.toString()}
                    query_name="getSitePerformances"
                    id={siteId}
                    params={{
                        time: { between: [startDate, endDate] },
                        types: ["DEET_PCS", "DEET_PCI", "DEET_GHG", "DPE_ENEP", "DPE_GHG", "CRREM_PCS", "CRREM_GHG"]
                    }}
                >
                    <SiteEnergeticPerformanceComponent />
                </QueryField>
            </div>
        </DetailsShow >
    )
};

export default SiteEnergeticPerformanceDetails;